import { useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import useAxiosPrivate from '../utils/useAxiosPrivate';
import { useAuth } from '../utils/AuthProvider';
import { usePhoneVerification } from '../utils/PhoneVerificationProvider';
import i18n from '../translationUtils/i18n';
import PhoneVerificationDialog from './PhoneVerificationDialog';

export default function PhoneVerificationBanner() {
    const { cookies } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const { refreshKey } = usePhoneVerification();

    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [preferredLanguage, setPreferredLanguage] = useState('en');
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        const getSettings = async () => {
            try {
                const response = await axiosPrivate.get('/api/User/settings/' + cookies.user, {
                    signal: controller.signal
                });

                const settings = response.data;
                setEmail(settings.email);
                setPhone(`${settings.countryCode} ${settings.cellPhone}`);
                setPreferredLanguage(settings.prefferedLanguage ?? 'en');
                setIsPhoneVerified(settings.isPhoneVerified ?? false);
                setSettingsLoaded(true);
            } catch (err) {
                console.log(err);
            }
        };

        getSettings();

        return () => {
            controller.abort();
        };
        // eslint-disable-next-line
    }, [refreshKey]);

    if (!settingsLoaded || isPhoneVerified) {
        return null;
    }

    return (
        <Box sx={{ padding: 2, paddingBottom: 0 }}>
            <Paper
                elevation={3}
                onClick={() => setDialogOpen(true)}
                sx={{
                    padding: 2,
                    cursor: 'pointer',
                    bgcolor: 'error.main',
                    color: 'error.contrastText',
                    '&:hover': { bgcolor: 'error.dark' }
                }}
            >
                <Typography variant="h6" gutterBottom>{i18n.t('phonenotverified')}</Typography>
                <Typography variant="body2">{i18n.t('phonenotverifiedwarning')}</Typography>
            </Paper>

            <PhoneVerificationDialog
                open={dialogOpen}
                email={email}
                phone={phone}
                preferredLanguage={preferredLanguage}
                axiosInstance={axiosPrivate}
                showMethodPicker={true}
                onVerified={() => setIsPhoneVerified(true)}
                onClose={() => setDialogOpen(false)}
            />
        </Box>
    );
}
